import {Column} from 'react-virtualized';
import get from '../../utils/get';

function columnIsFilterable(columnDefinition) {
  return columnDefinition.type === Column && columnDefinition.props.cellFilterer;
}

function getFilterDataForRow(columnDefinitions, rowData) {
  return columnDefinitions
    .filter(columnIsFilterable)
    .map(columnDefinition => getFilterDataForColumn(columnDefinition, rowData))
    .join(' ')
    .toLowerCase();
}

function getFilterDataForColumn(columnDefinition, rowData) {
  const {dataKey, cellFilterer} = columnDefinition.props;
  return cellFilterer({cellData: get(rowData, dataKey)});
}

export function buildFilterableStrings(data, columns) {
  return data.map(rowData => getFilterDataForRow(columns, rowData));
}

export function getFilteredIndexes(filterBy = '', rowsFilterableStrings) {
  return rowsFilterableStrings.reduce((filteredIndexes, rowFilterText, index) => {
    if (rowFilterText.indexOf(filterBy.toLowerCase()) > -1) {
      filteredIndexes.push(index);
    }
    return filteredIndexes;
  }, []);
}
